import '../scrollytelling.css'
import '../v3/office.css'
import './human.css'

import { SceneProvider, useScrollStory } from '../engine'
import HumanStory from './HumanStory'

/**
 * Version 4 „Der Mensch hinter dem Lebenslauf“: das Miniatur-Office aus v3,
 * erzählt als Vorher-Nachher. Erst eine Fehlbesetzung ohne Aivy, dann
 * zurückgespult und mit Aivy, inklusive Kreuzmatching und fairer Absagen.
 */
export default function ScrollytellingV4() {
  const story = useScrollStory(1, { mode: 'pin' })

  return (
    <div ref={story.storyRef} className='sty-root off-root hum-root'>
      <section
        ref={(el) => (story.chapterRefs.current[0] = el)}
        className='off-section'
        aria-label='Der Mensch hinter dem Lebenslauf'
      >
        <div
          ref={(el) => (story.sceneRefs.current[0] = el)}
          className='off-sticky'
        >
          <SceneProvider index={0} subscribe={story.subscribe}>
            <HumanStory />
          </SceneProvider>
        </div>
      </section>
    </div>
  )
}
